import auth from "./auth";
import admin from "./admin";
import channel from "./channel";
import feed from "./feed";
import post from "./post";
import user from "./user";
import client from "./client";
import achievement from "./achievement";
import student from "./student";
import newsletter from "./newsletter";
import email from "./email";
import elearning from "./elearning";
import author from "./author";
import topic from "./Topic";
import cart from "./cart";
import wishlist from "./wishlist";
import placeOrder from "./placeOrder";
import learningTracker from "./learningTracker";
import corporate from "./corporate";
import companydash from "./companydash";
import services from "./services";
import respitecare from "./respitecare";
import coach from "./coach";
import google from "./google";
import linkedin from "./linkedin";
import whatsapp from "./whatsapp";
import quote from "./mantra";
import subscribe from "./subscribe";
import transaction from "./transaction";
import payment from "./payment";
import pushNotification from "./pushNotification";
import testimonial from "./testimonial";
import karunaPoint from "./karunaPoint";
import hcp from "./hcp";
import cmsAuthor from "./cmsAuthor";
import meditation from "./meditation";
import aboutUs from "./aboutUs";
import affiliate from "./affiliate";
import doctor from "./doctor";
import hoc from "./hoc";
import membership from "./membership";
import coupon from "./coupon";
import features from "./planFeatures";
import ffc from "./ffc";
import homePageBanner from "./homePageBanner";
import playlist from "./playlist";
import mainAboutUs from "./main-about-us";
import homepage from "./homepage";
import wellbeingInitiative from "./wellbeingInitiative";
import globalForm from "./globalForm";
import medicalCancer from "./medicalCancer";
import podcast from "./podcast";
import quotes from "./quotes";

export default {
  auth: auth,
  client: client,
  achievement,
  channel: channel,
  feed: feed,
  post: post,
  user: user,
  admin: admin,
  student: student,
  newsletter: newsletter,
  email: email,
  elearning: elearning,
  author,
  topic,
  cart,
  wishlist,
  placeOrder,
  learningTracker,
  corporate: corporate,
  companydash: companydash,
  services: services,
  respitecare: respitecare,
  coach: coach,
  google,
  linkedin,
  whatsapp,
  quote,
  subscribe,
  transaction,
  payment,
  pushNotification,
  testimonial,
  karunaPoint,
  hcp,
  cmsAuthor,
  meditation,
  aboutUs,
  affiliate,
  doctor,
  hoc,
  membership,
  coupon,
  features,
  ffc,
  homePageBanner,
  playlist,
  mainAboutUs,
  homepage,
  wellbeingInitiative,
  globalForm,
  medicalCancer,
  podcast,
  quotes,
};
